// Firebase configuration & initialization
//
// This project uses Firebase for:
//   1. Firestore  -> stores course enrollment/applicant records for the Admin Dashboard
//   2. Auth        -> protects the Admin Dashboard behind an email/password login
//
// SETUP: create a Firebase project at https://console.firebase.google.com,
// enable "Email/Password" sign-in (Authentication -> Sign-in method) and
// enable Firestore (Firestore Database -> Create database).
// Then copy your web app config values into a `.env` file in the project
// root (see `.env.example`). Full step-by-step instructions are in
// ENROLLMENT_ADMIN_SETUP.md.

import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Avoid re-initializing during hot-reload
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

// Name of the Firestore collection that stores enrollment applications.
export const APPLICANTS_COLLECTION = "applicants";

export default app;
